import { useEffect, useState } from 'react';
import { useTheme } from '@/theme';
import { useTranslation } from '@/i18n';
import {
  initHelpScout,
  onHelpScoutEvent,
  offHelpScoutEvent,
  toggleHelpScout,
} from '@/utils/helpScout';

export const HelpScoutButton = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    initHelpScout();

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    onHelpScoutEvent('open', handleOpen);
    onHelpScoutEvent('close', handleClose);

    return () => {
      offHelpScoutEvent('open', handleOpen);
      offHelpScoutEvent('close', handleClose);
    };
  }, []);

  return (
    <button
      onClick={() => toggleHelpScout()}
      style={{
        background: 'none',
        border: 'none',
        padding: theme.spacing.sm,
        cursor: 'pointer',
        color: theme.colors.textSecondary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title={t('Menu:Help') || 'Help'}
      aria-label={t('Menu:Help') || 'Help'}
    >
      {isOpen ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ) : (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      )}
    </button>
  );
};
